module.exports = __webpack_public_path__ + "images/help/icon-twr37-a8749ca021e8719aaf6143615e06bfa7.png";